import { Button, Notice } from '@rental/ui'
import { AUTH_MODE } from '../api'
import { PageHeading } from '../components/ui'
import { useLocale } from '../i18n'
import { Frame } from './Frame'

/**
 * The API no longer accepts this version of the app (426). Nothing works
 * until it is updated: the iPad app from the store (A2), the web app by
 * loading its new version.
 */
export function UpdateScreen() {
  const { messages: m } = useLocale()
  const app = AUTH_MODE === 'token'
  return (
    <Frame>
      {/* The lock card's title and main button (UI-2g): every card before the PIN alike. */}
      <PageHeading className="text-xl">{m.update.title}</PageHeading>
      <Notice tone="warning">
        <p>{app ? m.update.app : m.update.web}</p>
      </Notice>
      {app ? null : (
        <Button
          variant="staff"
          block
          className="shadow-action"
          onClick={() => window.location.reload()}
        >
          {m.update.reload}
        </Button>
      )}
    </Frame>
  )
}
